/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment } from 'react'
import { KTIcon } from '../../../../helpers'

type Props = {
  className: string
  items?: Array<{ description: string; value: string | number }>
}

const defaultRows = [
  { description: 'Payment Mode', value: '0' },
  { description: 'Outstanding', value: '0' },
  { description: 'Overdue', value: '0' },
]

const ListsWidget26 = ({ className, items = defaultRows }: Props) => (
  <div className={`card card-flush ${className}`}>
    <div className='card-header pt-5'>
      <h3 className='card-title text-gray-800 fw-bold'>GST</h3>
      <div className='card-toolbar'></div>
    </div>
    <div className='card-body pt-5'>
      {items.map((item, index) => (
        <Fragment key={`lw26-rows-${index}`}>
          <div className='d-flex flex-stack'>
            <a href='#' className='text-primary fw-semibold fs-6 me-2'>
              {item.description}
            </a>
            <div className='d-flex align-items-center'>
              <span className='text-gray-800 fw-bold fs-6 me-3'>{item.value}</span>
              {/* <button
                type='button'
                className='btn btn-icon btn-sm h-auto btn-color-gray-400 btn-active-color-primary justify-content-end'
              >
                <KTIcon iconName='exit-right-corner' className='fs-2' />
              </button> */}
            </div>
          </div>
          {items.length - 1 > index && <div className='separator separator-dashed my-3' />}
        </Fragment>
      ))}
    </div>
  </div>
)
export { ListsWidget26 }